import axios from "axios";
import { getBackendBaseUrl } from "./utils/backendUrl";

const API = axios.create({
  baseURL: getBackendBaseUrl(),
  withCredentials: true,
  timeout: 20000,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    console.log('API request with token:', config.url);
  } else {
    console.warn('API request without token:', config.url);
  }
  return config;
});

// Add response interceptor to handle auth errors globally and empty responses
API.interceptors.response.use(
  (response) => {
    // Check for empty string responses
    if (response.data === '' || response.data === null) {
      console.error('⚠️ WARNING: Backend returned empty response!');
      console.error('   URL:', response.config?.url);
      console.error('   Status:', response.status);
      console.error('   Headers:', response.headers);
      
      // Try to return a default structure to prevent crashes
      if (response.config?.url?.includes('/api/monitoring/logs')) {
        console.warn('   Returning default empty logs structure');
        response.data = {
          logs: [],
          total: 0,
          page: 0,
          size: 0,
          hasMore: false,
          error: 'Backend returned empty response'
        };
      }
    }
    return response;
  },
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.error('Authentication error:', error.response.status);
      console.error('Error details:', error.response.data);
      console.error('Request URL:', error.config?.url);
      // Log token status for debugging
      const token = localStorage.getItem("token");
      if (token) {
        console.warn('Token exists but request was rejected. Token might be expired.');
        // Try to decode token to check expiration (basic check)
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          const exp = payload.exp * 1000; // Convert to milliseconds
          const now = Date.now();
          if (exp < now) {
            console.error('Token has expired. Expired at:', new Date(exp), 'Current time:', new Date(now));
          } else {
            console.log('Token is not expired. Expires at:', new Date(exp));
          }
        } catch (e) {
          console.warn('Could not decode token:', e);
        }
      } else {
        console.error('No token found in localStorage');
      }
    }
    return Promise.reject(error);
  }
);

export default API;
